import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from '../components/PageHeader';
import NewsUpdates from '../components/NewsUpdates';
import background4 from '../assets/background-4.jpg';

export default function News() {
    useEffect(() => {
        console.log('📄 News page loaded - requesting ALL items');
    }, []);
    
    return (
        <>
            <Navbar />
            <PageHeader title="News" path="/news" name="News" bgImage={background4} />
            <div className="news-page container-xxl py-5">
                <div className="container">
                    {/* maxItems undefined = show ALL news items */}
                    <NewsUpdates maxItems={undefined} />
                </div>
            </div>
            <Footer />
            <BackToTop />
        </>
    );
}
